const getRelativeMonthYearName = (monthsBack: number) => {
    const today = new Date();
    const lastMonth = new Date(today.getFullYear(), today.getMonth() - monthsBack, 1);
    const lastMonthYear = lastMonth.getFullYear();
    const lastMonthName = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(lastMonth);
    return `${lastMonthName} ${lastMonthYear}`;
};

export const relativeSegments = [
    {
        key: 'year',
        label: 'Year to Date',
    },
    {
        key: 'last-3-months',
        label: 'Last full 3 months',
    },
    {
        key: 'last-6-months',
        label: 'Last full 6 months',
    },
    {
        key: 'last-12-months',
        label: 'Last full 12 months',
    },
    {
        key: 'month',
        label: getRelativeMonthYearName(1),
    },
    {
        key: 'previous_month',
        label: getRelativeMonthYearName(2),
    },
] as const;

export const limitedFakeDateOptions = relativeSegments.slice(0, -1);

export const COMPARE_BAR_SEGMENTS = [
    {
        key: 'custom',
        label: 'Custom Range',
        isPanel: true,
    },
    ...relativeSegments,
] as const;
